"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoResourceSchema = void 0;
exports.VideoResourceSchema = {
    "$id": "https://www.redbull.com/schemas/abstract/video-resource.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "VideoResource",
    "type": "object",
    "required": [
        "type",
        "id",
        "attributes",
        "relationships"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:abstract:video-resource"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        },
        "attributes": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "audioStreamLanguages": {
                    "description": "A list of audio stream languages available for the video asset. This indicates the languages in which the video's audio stream can be listened to.",
                    "type": "array",
                    "items": {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/audio-language.schema.json"
                    }
                },
                "description": {
                    "description": "A list of text blocks containing textual event information. Not all elements may be presented to the user by default. Keep the first textual artefact concise (recommended less than 250 chars).",
                    "type": "array",
                    "items": {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
                    }
                },
                "contextualDescription": {
                    "description": "Context-specific variations of the description, tailored to meet the requirements of different use cases (e.g., EPG descriptions customized for syndication partners or other distribution channels).",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/attributes/contextual.schema.json"
                },
                "noEmbedding": {
                    "description": "If set to true, embedding should not be offered for this asset. Used for exclusive content that should only live on redbull.com",
                    "type": "boolean"
                },
                "subtitleLanguages": {
                    "description": "Available subtitle languages for the video asset in [RFC 5646](https://tools.ietf.org/html/rfc5646) notation. e.g. `en`, `en-US`, etc.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "isEuropeanWork": {
                    "description": "Video is a European Work according to the following guideline: https://digital-strategy.ec.europa.eu/en/policies/european-works - information patched by rbmn service",
                    "type": "boolean"
                },
                "videoDurationSeconds": {
                    "description": "Duration of the video in seconds.",
                    "type": "integer"
                },
                "videoEssence": {
                    "description": "Reference to video archive for playback (e.g. mediabase RBMN API)",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/type-groups/services/video.schema.json"
                },
                "videoFrameAspectRatio": {
                    "description": "Aspect ratio of the video frame (width / height)",
                    "type": "number"
                }
            }
        },
        "relationships": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "sponsoredBy": {
                    "type": "object",
                    "description": "The partner who sponsored the creation of a content piece (financial or other support)",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
                            }
                        }
                    }
                }
            }
        },
        "links": {
            "type": "object",
            "additionalProperties": {
                "type": [
                    "object",
                    "string"
                ],
                "description": "A link **MUST** be represented as either: a string containing the link's URL or a link object.",
                "oneOf": [
                    {
                        "description": "A string containing the link's URL.",
                        "type": "string",
                        "format": "uri-reference"
                    },
                    {
                        "type": "object",
                        "required": [
                            "href"
                        ],
                        "properties": {
                            "href": {
                                "description": "A string containing the link's URL.",
                                "type": "string",
                                "format": "uri-reference"
                            },
                            "meta": {
                                "description": "Non-standard meta-information that can not be represented as an attribute or relationship.",
                                "type": "object",
                                "additionalProperties": true
                            }
                        }
                    }
                ]
            }
        },
        "meta": {
            "additionalProperties": true,
            "type": "object"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,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